import { addressOf, type Area } from '../shell/area-address.js';
import type { Action } from '../contract.js';

/** Keep canonical API paths usable while MA4/MA5 still use the existing screens. */
export function actionAddress(action: Extract<Action, { kind: 'open' }>): string {
  const url = new URL(action.path, window.location.origin);
  const parts = url.pathname.split('/').filter(Boolean);
  let base = action.path;
  if (parts[0] === 'admin') {
    if (parts[1] === 'people' && parts[2] === 'person' && parts[3]) base = addressOf({ person: decodeURIComponent(parts[3]) });
    else if (parts[1] === 'people' && parts[2] === 'group' && parts[3]) base = addressOf({ group: decodeURIComponent(parts[3]) });
    // The server's short forms: /admin/people/<principalId> and /admin/groups/<groupId>.
    else if (parts[1] === 'people' && parts[2] && !['add', 'changes'].includes(parts[2])) base = addressOf({ person: decodeURIComponent(parts[2]) });
    else if (parts[1] === 'groups' && parts[2]) base = addressOf({ group: decodeURIComponent(parts[2]) });
    else {
      const area = parts[1] === 'people' && (parts[2] === 'add' || parts[2] === 'changes') ? parts[2] : parts[1];
      if (area && ['people', 'sources', 'privacy', 'spend', 'decides', 'policy', 'vault', 'powers', 'add', 'changes'].includes(area)) {
        base = addressOf({ area: area as Area });
      }
    }
  } else if (url.pathname === '/rails') {
    const tab = url.searchParams.get('tab'), view = url.searchParams.get('view');
    const person = url.searchParams.get('person'), group = url.searchParams.get('group');
    if (tab === 'access' && view === 'person' && person) base = addressOf({ person });
    else if (tab === 'access' && view === 'group' && group) base = addressOf({ group });
    else {
      const area = tab === 'access' ? 'people' : tab === 'people' ? 'add' : tab === 'connectors' ? 'sources'
        : tab === 'brains' ? 'decides' : tab === 'rails' ? (url.searchParams.get('railsTab') === 'policy' ? 'policy' : 'privacy') : null;
      if (area) base = addressOf({ area });
    }
    if (base !== action.path || tab === 'access') {
      // Routing keys belong to the table. Keep the action's filters and requested confirm.
      for (const key of ['tab', 'view', 'person', 'group', 'railsTab']) url.searchParams.delete(key);
    }
  } else if (url.pathname === '/usage') base = addressOf({ area: 'spend' });
  else if (url.pathname === '/superadmin') base = addressOf({ area: 'vault' });
  const destination = new URL(base, window.location.origin);
  for (const [key, value] of url.searchParams) destination.searchParams.set(key, value);
  if (action.open) destination.searchParams.set('open', action.open);
  destination.hash = url.hash;
  return `${destination.pathname}${destination.search}${destination.hash}`;
}
export function navigate(path: string): void {
  window.history.pushState(null, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}
